import { FC } from "react";
import st from "./style.module.css";

export const Paper: FC = ({ children }) => {
  return <div className={st.paper}>{children}</div>;
};
